

export function getParameterType(row) {
    if (row.DataType == "bit_decimal_16" && row.FloatPoint == 1) {
        return "D.WR"
    } else if (row.DataType == "bit_undecimal_16" && row.FloatPoint == 1) {
        return "D.SH"
    } else if (row.DataType == "bit_decimal_32" && row.FloatPoint == 1) {
        return "D.IN"
    } else if (row.DataType == "bit_decimal_32" && row.FloatPoint == 2) {
        return "D.IN2"
    } else if (row.DataType == "bit_undecimal_32" && row.FloatPoint == 1) {
        return "D.DW"
    } else if (row.DataType == "bit_float_32" && row.FloatPoint == 1) {
        return "D.FT"
    } else if (row.DataType == "bit_float_32" && row.FloatPoint == 2) {
        return "D.FT2"
    } else if (row.DataType == "bit_double_64" && row.FloatPoint == 1) {
        return "D.DB"
    } else if (row.DataType == "bit_double_64" && row.FloatPoint == 7) {
        return "D.DB7"
    } else {
        return 'not-found'
    }
}